


const displayEMSVideoList:any = [];
const uploadEMSVideoList:any = [];
const gumVideo:any = '';

export const EMSVideoService = {
    displayEMSVideoList,
    uploadEMSVideoList,
    gumVideo
  };